// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__3JKCk","hyphen":"styles_hyphen___8Zb6","borderB":"styles_borderB__zQBC_","borderRB":"styles_borderRB__ZeuUg","disc":"styles_disc__bQTlp"};